/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * ShoppingCartIcon - Auto-generated from icon.js
 */
export const ShoppingCartIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M11.5497 25.8C9.98226 25.8 8.71405 27.0825 8.71405 28.65C8.71405 30.2175 9.98226 31.5 11.5497 31.5C13.1172 31.5 14.3996 30.2175 14.3996 28.65C14.3996 27.0825 13.1172 25.8 11.5497 25.8ZM3 3V5.85H5.8499L10.9797 16.6657L9.05604 20.157C8.82805 20.556 8.6998 21.0262 8.6998 21.525C8.6998 23.0925 9.98226 24.375 11.5497 24.375H28.6491V21.525H12.1482C11.9487 21.525 11.7919 21.3682 11.7919 21.1687L11.8347 20.9977L13.1172 18.675H23.733C24.8018 18.675 25.7422 18.0907 26.2267 17.2072L31.328 7.959C31.4456 7.74153 31.5047 7.49727 31.4997 7.2501C31.4947 7.00293 31.4256 6.7613 31.2992 6.5488C31.1729 6.33631 30.9936 6.16022 30.7789 6.03774C30.5641 5.91526 30.3213 5.85057 30.0741 5.85H8.99904L7.65959 3H3ZM25.7992 25.8C24.2318 25.8 22.9636 27.0825 22.9636 28.65C22.9636 30.2175 24.2318 31.5 25.7992 31.5C27.3667 31.5 28.6491 30.2175 28.6491 28.65C28.6491 27.0825 27.3667 25.8 25.7992 25.8Z"
			fill="current"
		/>
	</svg>
);

export default ShoppingCartIcon;
